import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';

import * as CgIcons from 'react-icons/cg';
import * as AiIcons from 'react-icons/ai';

import SpayImages from '../../../../modules/public/spayimages';
import { sidebarBottom, customNav } from '../../../../shared/infrastructure/router';
import { stringToTitleCase } from '../../../../shared/helpers/utils';
import Clipboard from '../../../../shared/components/clipboard';

import { ReactComponent as Selected } from '../../../../assets/images/svg/selected.svg';
import ToggleButton from './components/toggle_button';
import LogoutButton from '../../../../shared/components/logout-Button/logout-button';

function SideBar(props) {
    const history = useHistory();
    const { isToggled, setToggle, merchantDetails = [], firstAccess, onNavListCloser, setSwitch } = props;
    const { SpayLogo, TestUser } = SpayImages();

    const [state, setState] = useState({
        isUserCardOpen: false,
        selectedBusiness: merchantDetails?.[0]?.id || ''
    });

    useEffect(() => {
        const id = merchantDetails?.[0]?.id;
        if (id) {
            setState(prev => ({ ...prev, selectedBusiness: id }));
        }
    }, [merchantDetails]);

    const handleActiveNav = (item, type) => {
        if (history.location.pathname.includes(`/settings`) && type === 'settings') {
            return history.location.pathname.includes(`/settings`) ? `oi-nav__link--active` : '';
        }

        const isExactOrChild =
            history.location.pathname === item.path ||
            (item.path !== '/' && history.location.pathname.startsWith(`${item.path}`));

        return isExactOrChild ? `oi-nav__${type}--active` : '';
    };

    const toggleUserCard = () => {
        setState(prev => ({ ...prev, isUserCardOpen: !prev.isUserCardOpen }));
    };

    const selectBusiness = id => {
        setState(prev => ({ ...prev, selectedBusiness: id, isUserCardOpen: false }));
        if (typeof setSwitch === 'function') {
            setSwitch(id);
        }
    };

    const handleNavClick = () => {
        if (isToggled) {
            if (typeof onNavListCloser === 'function') {
                onNavListCloser();
            } else if (typeof setToggle === 'function') {
                setToggle();
            }
        }
    };

    const currentMerchant = merchantDetails?.[0] || {};
    const businessName = stringToTitleCase(currentMerchant.businessName || 'Business');
    const merchantCode = currentMerchant.merchantCode || '';

    return (
        <React.Fragment>
            {!isToggled && (
                <button
                    type="button"
                    className="oi-sidebar__mobile-toggle"
                    onClick={setToggle}
                    aria-label="Open navigation sidebar"
                    aria-controls="dashboard-sidebar">
                    <AiIcons.AiOutlineMenu />
                </button>
            )}
            <aside
                id="dashboard-sidebar"
                className={`${isToggled ? 'oi-sidebar--collapsed oi-sidebar--expand' : ''} oi-sidebar`}>
                <div className="oi-sidebar__resizer">
                    {/* Sidebar brand and collapse controls */}
                    <div className="oi-sidebar__header">
                        <div className="spay-brand">
                            <img className="spay-brand__logo" src={SpayLogo} alt="SPay Logo" />
                        </div>
                        <button
                            type="button"
                            className="oi-sidebar__toggle-btn"
                            onClick={setToggle}
                            aria-label={isToggled ? 'Expand sidebar' : 'Collapse sidebar'}
                            aria-controls="dashboard-sidebar"
                            title={isToggled ? 'Expand sidebar' : 'Collapse sidebar'}>
                            <AiIcons.AiOutlineMenu />
                        </button>
                        <button
                            type="button"
                            className="oi-close-btn"
                            onClick={setToggle}
                            aria-label="Close Sidebar">
                            <CgIcons.CgClose />
                        </button>
                    </div>

                    {/* Business Profile Card */}
                    <div className="oi-user">
                        <div className="oi-user__wrap">
                            <div className="oi-user__img-wrap">
                                <img className="oi-user__img" src={TestUser} alt={businessName} />
                                <span className="oi-user__status-dot" title="Active Business" />
                            </div>

                            <div className="oi-user__info">
                                <div className="oi-user__header-row">
                                    <h2 className="oi-user__name" title={businessName}>
                                        {businessName}
                                    </h2>
                                    {merchantDetails?.length > 1 && (
                                        <button
                                            type="button"
                                            className={`oi-user__toggle-btn ${
                                                state.isUserCardOpen ? 'oi-user__toggle-btn--open' : ''
                                            }`}
                                            onClick={toggleUserCard}
                                            title="Switch Business"
                                            aria-label="Switch Business">
                                            <CgIcons.CgChevronDown />
                                        </button>
                                    )}
                                </div>

                                <div className="oi-user__id-badge" title={merchantCode ? `Merchant Code: ${merchantCode}` : ''}>
                                    <span
                                        className="oi-user__id-text"
                                        style={{
                                            maxWidth: 'none',
                                            overflow: 'visible',
                                            textOverflow: 'clip',
                                            whiteSpace: 'nowrap'
                                        }}>
                                        {merchantCode || '---'}
                                    </span>
                                    {merchantCode && (
                                        <Clipboard inline input={merchantCode} />
                                    )}
                                </div>
                            </div>
                        </div>

                        {merchantDetails?.length > 1 && state.isUserCardOpen && (
                            <div className="oi-user__list-business oi-user__list-business-expand">
                                <div className="oi-user__dropdown-title">Switch Business</div>
                                {merchantDetails.map((detail, idx) => {
                                    const isSameId = state.selectedBusiness === detail.id;
                                    return (
                                        <div
                                            className={`oi-user__lists ${
                                                isSameId ? 'oi-user__lists--active' : ''
                                            }`}
                                            key={idx}
                                            onClick={() => selectBusiness(detail.id)}>
                                            <span className="oi-user__lists-name">{detail.businessName}</span>
                                            {isSameId && <Selected className="oi-user__selected-icon" />}
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>

                    {/* Navigation Container */}
                    <div className={`oi-nav__container ${firstAccess ? 'u-hide' : ''}`}>
                        <nav className="oi-nav">
                            {customNav.map((element, idx) => {
                                const headerText = element.label?.name;
                                return (
                                    <div key={idx} className="oi-nav__group">
                                        {headerText && (
                                            <h3 className="oi-nav__nav-header">
                                                {headerText.toUpperCase()}
                                            </h3>
                                        )}

                                        <ul className="oi-nav__list">
                                            {element.content.map((item, itemIdx) => {
                                                const isActiveLink = handleActiveNav(item, 'link');
                                                const isActiveIcon = handleActiveNav(item, 'icons');

                                                return (
                                                    <li className="oi-nav__item" key={itemIdx}>
                                                        <Link
                                                            to={item.path}
                                                            onClick={handleNavClick}
                                                            title={item.name}
                                                            className={`${isActiveLink} oi-nav__link`}>
                                                            <span className={`${isActiveIcon} oi-nav__icons`}>
                                                                {item.icon}
                                                            </span>
                                                            <span className="oi-nav__name">{item.name}</span>
                                                        </Link>
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    </div>
                                );
                            })}
                        </nav>

                        {/* Bottom Settings & Controls Dock */}
                        <div className="oi-settings">
                            <nav className="oi-nav oi-nav--bottom">
                                <ul className="oi-nav__list">
                                    <li className="oi-nav__item">
                                        <ToggleButton />
                                    </li>

                                    {sidebarBottom.map((route, id) => {
                                        const isActiveLink = handleActiveNav(route, 'settings');
                                        const isActiveIcon = handleActiveNav(route, 'settings');

                                        return (
                                            <li className="oi-nav__item" key={id}>
                                                <Link
                                                    to={route.path}
                                                    onClick={handleNavClick}
                                                    title={route.name}
                                                    className={`${isActiveLink} oi-nav__link`}>
                                                    <span className={`${isActiveIcon} oi-nav__icons`}>
                                                        {route.icon}
                                                    </span>
                                                    <span className="oi-nav__name">{route.name}</span>
                                                </Link>
                                            </li>
                                        );
                                    })}

                                    <li className="oi-nav__item">
                                        <LogoutButton />
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </aside>
        </React.Fragment>
    );
}

export default SideBar;
